module.exports = __webpack_public_path__ + "static/GQLANALYSIS-14cf83ffe469fc99b09d9a06948fc1f0.png";